<ng-template #content let-modal>
    <div class="modal-header">
        <h4>{{modalHeader}}</h4>
    </div>

    <div class="modal-body">
        <form>
            <div class="col-md-12 form-group">
                <label class="detail-name" for="recipient">To</label>
                <input class="form-control" [(ngModel)]="supportEmail" name="recipient" disabled>
            </div>

            <div class="col-md-12 form-group">
                <label class="detail-name" for="subject">Subject *</label>
                <input class="form-control" [(ngModel)]="data.subject" name="subject">
            </div>

            <div class="col-md-12 form-group">
                <label class="detail-name" for="body">Write a Message *</label>
                <textarea placeholder="Describe your problem here" class="form-control" [(ngModel)]="userInput" name="body" rows="5"></textarea>
            </div>
        </form>
    </div>

    <span class="col-md-3">* Required</span>

    <div class="modal-footer" style="border: none">
        <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="modal.dismiss('Cross click')">Cancel</button>
        <button *ngIf="!isWaiting" [disabled]="!isInputValid()" type="button" class="btn btn-primary btn-lg"
            (click)="modalSubmitted()">{{submitButtonText}}</button>
        <app-loading-spinner *ngIf="isWaiting" text="Sending..."></app-loading-spinner>
    </div>

</ng-template>
